module.exports = __webpack_public_path__ + "static/media/UploadYourDocumentation.01c5f947.PNG";